export const NotificationTab = {
    Messages: 'messages',
    SuperSocial: 'supersocial',
} as const;
export type NotificationTab = typeof NotificationTab[keyof typeof NotificationTab];
